import { Alert, AlertTitle, Box, Button, Typography } from "@mui/material";
import React, { ErrorInfo, ReactNode } from "react";
import { captureException } from "services/monitoring";

interface ErrorHandlerProps {
  children: ReactNode;
}

interface ErrorHandlerState {
  hasError: boolean;
}

class ErrorHandler extends React.Component<ErrorHandlerProps, ErrorHandlerState> {
  state: ErrorHandlerState = {
    hasError: false,
  };

  componentDidCatch(error: Error, info: ErrorInfo): void {
    captureException(error, { componentStack: info?.componentStack });
    this.setState({ hasError: true });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}>
          <Alert severity="error" sx={{ minWidth: "300px" }}>
            <AlertTitle>Error</AlertTitle>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Something went wrong. Try refreshing the browser!
            </Typography>
            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
              <Button variant="contained" onClick={() => window.location.reload()}>
                Reload
              </Button>
            </Box>
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorHandler;
